module.exports = __webpack_public_path__ + "static/media/bg_5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_5.png
// module id = 50
// module chunks = 0